import { ColumnProps } from "antd/lib/table";
import { useContext, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import Space from "../../general/antd/space";
import EditBtn from "../../general/table-components/actions/edit-btn";
import Table from "../../general/table-components/table";
import AppsContext from "../../../context/apps/context";
import AppContext from "../../../context/app/context";
import styles from "../../../pages/area/style.module.scss";
import PageHeader from "../../general/layout/page-header";
import AppsContextProvider from "../../../context/apps/provider";
import RefreshBtn from "../../general/table-components/actions/refresh-btn";
import { IApps } from "../../../models/apps/response";
import Image from "../../general/antd/image";
import { LinkOutlined } from "@ant-design/icons";
import { AppleOutlined, AppstoreOutlined } from "@ant-design/icons/lib/icons";

interface IProps {
}

const AppsTable: React.FC<IProps> = (props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const { list, actions, loading } = useContext(AppsContext);
    const { direction } = useContext(AppContext);

    useEffect(() => {
        actions.getData();
    }, [direction]);

    const columns: ColumnProps<IApps>[] = [
        {
            title: t("id"),
            dataIndex: "id",
            key: "id",
            sorter: {
                multiple: 1,
            },
            width: 100,
            align: "center",
        },
        {
            title: t("name"),
            dataIndex: "name",
            align: "center",
            key: "name",
            sorter: {
                multiple: 2,
            },
        },
        {
            title: t("message"),
            dataIndex: "message",
            align: "center",
            key: "message",
            sorter: {
                multiple: 2,
            },
        },
        {
            title: t("app_store_link"),
            dataIndex: "app_store_link",
            key: "app_store_link",
            align: "center",
            render: (link) => link ? <a href={link} target="_blank" rel="noopener noreferrer">
                <AppleOutlined style={{ fontSize: 18 }} />
            </a> : "-",
        },
        {
            title: t("play_store_link"),
            dataIndex: "play_store_link",
            key: "play_store_link",
            align: "center",
            render: (link) => link ? <a href={link} target="_blank" rel="noopener noreferrer">
                <AppstoreOutlined style={{ fontSize: 18 }} />
            </a> : "-",
        },
        {
            title: t("direct_link"),
            dataIndex: "direct_link",
            key: "direct_link",
            align: "center",
            render: (link) => link ? <a href={link} target="_blank" rel="noopener noreferrer">
                <LinkOutlined style={{ fontSize: 18 }} />
            </a> : "-",
        },
        {
            key: "image",
            title: t("image"),
            dataIndex: "brandImage",
            align: "center",
            render: (_, record) => {
                if (record?.image) {
                    const baseUrl = process.env.REACT_APP_TEST_UPLOAD_FILE_URL;
                    const imageUrl = `${baseUrl}${record.image}`;
                    return <Image src={imageUrl} height={"25px"} preview={true} />
                } else
                    return "-";

            },
        },
        {
            title: t("actions"),
            width: 250,
            dataIndex: "",
            align: "center",
            key: "x",
            render: (_: any, record) => (
                <Space>
                    <EditBtn
                        onClick={async () => {
                            navigate(`update/${record?.id}`, { state: { initialValues: record } })
                        }}
                    />
                </Space>
            ),
        },
    ];
    return (
        <div dir={direction} className={styles.container}>
            <PageHeader
                title={t("apps")}
                subTitle={t("apps_versions")}
                extra={[
                    <RefreshBtn
                        key={0}
                        loading={loading.includes("list")}
                        onClick={() => actions.getData()}
                    >
                        {t("refresh")}
                    </RefreshBtn>,
                ]}
            />
            <Table<any>
                rowKey="id"
                columns={columns}
                dataSource={list ?? []}
                loading={loading.includes("list")}
                size="small"
            />
        </div>
    );
};

const AppsPage = () => {
    return (
        <AppsContextProvider>
            <AppsTable />
        </AppsContextProvider>
    );
};
export default AppsPage;
